// KEDİ PROFİLİ SEKMELERİ — TEK DOĞRULUK KAYNAĞI
//
// PLAN-14 v2'de ölçülen hata: tasarım panosunun iki ekranı aynı dört hedefi
// İKİ FARKLI SIRAYLA ve iki farklı etiketle çiziyordu (Ekran 1: Bilgiler ·
// Yorumlar · Fotoğraflar · Harita — Ekran 2: Temel bilgiler · Fotoğraflar ·
// Yorumlar · Harita). Sıra ve etiket iki yerde yazılırsa er ya da geç ayrışır;
// kullanıcının kas hafızası bozulur, aynı iki dokunuş iki farklı yere gider.
//
// Bu yüzden sıra, etiket, ikon ve rota parçası YALNIZCA burada tanımlanır.
// Sekme çubuğu da, rotalar da, denetim de bu listeyi okur. Listeyi değiştiren
// tek bir yerden değiştirir.
//
// KARAR (6 Eylül 2026, kullanıcı onayı — PLAN-14 v3 §1):
//   Model A — tek çubuk, ALTTA. Ekran 2'nin üst sekme satırı yok.
//   "Genel" profilin kökü ve varsayılan sekmesi; kök rota `/cats/:id`.
//
// KARAR REVİZYONU (6 Eylül akşamı, kullanıcı):
//   1. Uygulamanın ANA ALT BARI kedi profilinde de kalır — orta "Kedi
//      bildir" düğmesi profilde de erişilebilir olmalı.
//   2. Profilin kendi sekme çubuğu ana alt barın **hemen ÜSTÜNDE** durur.
//      Üst sekme satırı denendi ve reddedildi: "başka bir yere giriyormuşuz
//      gibi" hissettiriyor.
//   3. Çubukta panodaki gibi **DÖRT** sekme var: Bilgiler · Yorumlar ·
//      Fotoğraflar · Harita. "Genel" çubukta GÖRÜNMEZ — o profilin kökü,
//      bir hedefi değil. Genel'e dönüş panodaki ‹ oku ile.

// `cubukta: false` → rota var, sekme var, ama ÇUBUKTA çizilmez.
// Panonun alt çubuğunda dört öğe var ve hiçbiri "Genel" değil; Genel zaten
// açık olduğun ekran. Sıra panonun Ekran 1'indeki sıradır.
export const KEDI_SEKMELERI = [
  { id: "genel",       slug: "",             tr: "Genel",    en: "Overview", cubukta: false },
  { id: "bilgiler",    slug: "bilgiler",     tr: "Bilgiler", en: "Details"  },
  { id: "yorumlar",    slug: "yorumlar",     tr: "Yorumlar", en: "Comments" },
  { id: "fotograflar", slug: "fotograflar",  tr: "Fotoğraflar", en: "Photos" },
  { id: "harita",      slug: "harita",       tr: "Harita",   en: "Map"      },
];

/** Çubukta çizilecek sekmeler: açık VE `cubukta` kapalı olmayanlar. */
export const cubuktakiSekmeler = () =>
  KEDI_SEKMELERI.filter((s) => s.cubukta !== false && ACIK_SEKMELER.includes(s.id));

// Kök sekmenin slug'ı boştur: `/cats/abc` = Genel. Diğerleri `/cats/abc/<slug>`.
export const VARSAYILAN_SEKME = "genel";

// HANGİ SEKME GERÇEKTEN VAR — kabuk ile içerik ayrı dilimlerde geliyor.
//
// Deponun kuralı: "sayfa hiçbir adımda yarım kalmaz". Beş sekmelik bir çubuk
// çizip dördünde "hazırlanıyor" yazmak, çubuğu hiç çizmemekten kötüdür:
// kullanıcı dokunur, boş ekran görür, bir daha denemez.
//
// Bu yüzden çubuk YALNIZCA burada açık yazan sekmeleri çizer ve kapalı bir
// sekmenin rotası köke yönlendirir. Her dilim kendi sekmesini bitirdiği
// COMMIT'te bu listeye ekler — daha önce değil. Liste tek elemanlıyken çubuk
// hiç çizilmez, yani bugünkü sayfa aynen çalışmaya devam eder.
//
//   Dilim B → "genel" (açık)   Dilim D → "bilgiler" (AÇILDI: sayfanın geri
//   kalanı oraya taşındı; panonun 2×4 ızgarası hâlâ Dilim D'nin işi)
//   Dilim E → "yorumlar"             Dilim F → "fotograflar", "harita"
export const ACIK_SEKMELER = ["genel", "bilgiler"];

export const sekmeAcikMi = (id) => ACIK_SEKMELER.includes(id);
// Çubuk, çizilecek EN AZ BİR hedef varsa çizilir. Eskiden ölçüt
// "iki açık sekme"ydi; "Genel" çubuktan çıkınca o ölçüt yanlış sayıyı
// sayar hâle geldi (iki açık sekmeden biri hiç çizilmiyor).
export const cubukCizilsinMi = () => cubuktakiSekmeler().length > 0;

// URL parçasından sekme kimliği. Bilinmeyen parça (ör. `/cats/abc/edit`) için
// null döner — çağıran o zaman sekme kabuğunu HİÇ çizmez. Bu bilerek böyle:
// `/cats/:id/edit` ayrı bir sayfadır, profilin bir sekmesi değil.
export function sekmeIdBul(slug) {
  if (!slug) return VARSAYILAN_SEKME;
  const bulunan = KEDI_SEKMELERI.find((s) => s.slug === slug);
  return bulunan ? bulunan.id : null;
}

export function sekmeYolu(catId, sekmeId) {
  const s = KEDI_SEKMELERI.find((x) => x.id === sekmeId);
  if (!s) return `/cats/${catId}`;
  return s.slug ? `/cats/${catId}/${s.slug}` : `/cats/${catId}`;
}

export function sekmeEtiketi(sekme, lang) {
  return lang !== "tr" ? sekme.en : sekme.tr;
}

// Yüzen alt çubuğun KAPLADIĞI dikey alan (css px).
//
// Panoda ölçüldü: çubuk gövdesi ~56, kapsayıcı (kenar boşluğu + gölge) ~68.
// Bu sayı yalnızca görsel bir sabit değil — kaydırılan içeriğin alt dolgusu
// bundan KÜÇÜK olursa listenin son öğesi çubuğun arkasında kalır. Panoda
// Ekran 2'de "Mahalleden notlar"ın ikinci notu tam olarak böyle örtülüyordu.
// Tezgâhın `sonda_ortulen` ölçütü bu sabiti sınar.
// TARAYICIDA ÖLÇÜLDÜ (6 Eyl, önizleme tezgâhı): çubuğun kapladığı gerçek alan
// **84 px** — 56 (öğe) + 12 (iç dolgu) + 8 (alt kenar boşluğu) + 8 (güvenli
// alan tabanı). İlk yazdığım 68 panodan göz kararıydı ve **16 px eksikti**:
// "Son fotoğraflar" şeridinin son satırı çubuğun altında kalıyordu — panoda
// Ekran 2'de gördüğümüz örtülmenin aynısı, bu sefer kendi kodumda.
// Dolgu, ölçülen değerin üstüne 4 px pay ile bağlandı.
export const SEKME_CUBUGU_YUKSEKLIGI = 88;

// Bir yol KEDİ PROFİLİNİN kendisi (ya da bir sekmesi) mi?
//
// Layout bunu kabuğu gizlemek için kullanıyor: profil kendi yüzen çubuğunu
// çiziyor, Layout'un alt barı da çizilirse ikisi üst üste biner.
// Kapsam DIŞI olanlar bilerek: `/cats` (liste), `/cats/new` (yeni kayıt) ve
// `/cats/:id/edit` (ayrı sayfa, sekme değil).
export function kediProfiliMi(yol) {
  const p = String(yol || "").split("/").filter(Boolean);
  if (p[0] !== "cats" || p.length < 2 || p.length > 3) return false;
  if (p[1] === "new") return false;
  if (p.length === 2) return true;
  return KEDI_SEKMELERI.some((s) => s.slug && s.slug === p[2]);
}
